import { useCallback } from 'react'
import { useParams } from 'react-router'
import ButtonModalSortList, { ItemSortFunction } from '../../../../../../../../baseComponents/Sorts/ButtonModalSortList'
import { BaseButtonModalSortListProps } from '../../../../../../../../baseComponents/Sorts/ButtonModalSortList/types'
import { twinFetchPostText } from '../../../../../../../../utils/globals/data'


interface VariantValuesSortButtonProps extends BaseButtonModalSortListProps { }

const VariantValuesSortButton: React.FC<VariantValuesSortButtonProps> = ({ ...rest }) => {
    const { updateOrder } = useVariantValuesSortButtonLogic()
    const { VariantId } = useParams()
    return (
        <ButtonModalSortList updateData={updateOrder} getDataFrom='/api/app/product/productVariant/variantValue/getAllVariantValues' {...rest} extraWhereParams={{ VariantGroupId: VariantId }} />
    )
}

const useVariantValuesSortButtonLogic = () => {
    const updateOrder: ItemSortFunction = useCallback(async (data) => {
        const resp = await twinFetchPostText('/api/app/product/productVariant/variantValue/updateVariantValuesOrder', { variantValues: data })
        if (resp) {
            return true
        }
        return false
    }, [])

    return { updateOrder }
}

export default VariantValuesSortButton